import React from 'react';
// import { Link, useParams } from 'react-router-dom';
// import ReactHtmlParser from 'react-html-parser';
import styled from "styled-components";
import { useDispatch, useSelector} from "react-redux";
import { getLayout } from "./../../../store/settings/selectors";
import { getTranslations, getLocale } from "./../../../store/localization/selectors";
import {toggleFilters} from "./../../../store/settings/actions";

import {LAYOUT_XS, LAYOUT_SM} from './../../../settings';

import Logo from './../../../components/App/Logo';
// import Container from './../../../components/App/Container';
import Spacer from './../../../components/App/Spacer';
import Image from './../../../components/App/Image';
import Button from "./../../../components/App/Button";

import heroImage from './../assets/home-bg-2026.png';
import heroLogo from './../assets/logo-terra.png';

import organizedVrf from './logo-vrf.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100%;

  height: calc(100vh - 50px);
  height: calc(calc(var(--vh, 1vh) * 100) - 50px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const MainContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* min-height: 100%; */
  flex-grow: 1;
  flex-shrink: 1;
  overflow: auto;
  text-align: center;
`;



const LogoWrapper = styled.div`
  max-width: 90%;
`;

const Hero = styled.div`
  width: 100%;
  height: ${props => props.mobile ? 'auto' : 'auto'};
  position: relative;
  padding: 30px;
  padding-left: ${props => props.mobile ? '30px' : '100px'};
  padding-right: ${props => props.mobile ? '30px' : '40px'};
  background-image: url('${props => props.background}');
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  border-bottom-left-radius: 80px;
  border-bottom-right-radius: 80px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-around;
`;

const HeroText = styled.div`
  font-size: ${props => props.mobile ? 24 : 38}px;
  line-height: ${props => props.mobile ? 30 : 52}px;
  color: #2A2A2A;
  font-weight: 300;
  text-transform: uppercase;

  text-align: ${props => props.mobile ? "center" : "left"};
`;
const HeroTitle = styled.div`
  font-weight: bold;
`;
const HeroSubtitle = styled.div`
  font-weight: normal;
`;
const HeroLogo = styled.div`
  float: right;
`;

const OrganizedBy = styled.div`
  padding-bottom: 15px;
  font-size: 18px;
  line-height: 20px;
  font-weight: 400;
`;
const OrganizedByLogos = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 45px;
  & > * {
    padding: 0px 10px;
  }
`;


export default function Home(){

  const dispatch = useDispatch();
  dispatch(toggleFilters(false));

  const layout = useSelector(getLayout);
  const translations = useSelector(getTranslations);
  const lang = useSelector(getLocale);
  // const config = useSelector(getConfig);

  let imageWidth = 600;
    if (layout === LAYOUT_XS || layout === LAYOUT_SM) {
      imageWidth = 500;
    }

    let logoWidth = 130;
    if (layout === LAYOUT_XS || layout === LAYOUT_SM) {
      logoWidth = 80;
    }

  return (
    <Wrapper>
      <MainContainer>
        <Hero mobile={layout === LAYOUT_XS || layout === LAYOUT_SM} background={heroImage} id="hero">
          {(layout !== LAYOUT_XS && layout !== LAYOUT_SM) && (
            <HeroLogo>
              <Image src={heroLogo} width={{ value: imageWidth, unit: "px" }} />
            </HeroLogo>
          )}
          <HeroText mobile={layout === LAYOUT_XS || layout === LAYOUT_SM}>
            <Logo height={{ value: logoWidth, unit: "px" }} variant="default" />
            {(layout === LAYOUT_XS || layout === LAYOUT_SM) ? (
              <Image src={heroLogo} width={{ value: 300, unit: "px" }} />
            ) : <Spacer size={{ value: 110, unit: "px" }} />}
            <HeroTitle>
              {translations["homepage"]["_home-title"]}
            </HeroTitle>
            <HeroSubtitle>
              {translations["homepage"]["_home-text"]}
            </HeroSubtitle>
            {/* 
            <br /><br />
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={`https://www.fieragricola.it/${lang}`}
            >
              <Button>{translations.homepage?._home_cta}</Button>
            </a>
            */}
          </HeroText>
        </Hero>
        
        <center>
        <br/><br/><br/>
          <OrganizedBy>
            {translations["homepage"]["_home-organized-by"]}            
          </OrganizedBy>
          <OrganizedByLogos>
            <Image src={organizedVrf} width={{"value": 150, "unit": "px"}}/>
          </OrganizedByLogos>
        </center>
      </MainContainer>
    </Wrapper>
  );

}
